import React from "react";
import { Button, Tooltip } from "antd";
import CollectionIcon from "../../../assets/images/collection-icon.svg";
import DisabledCollectionIcon from "../../../assets/images/disabled-collection-icon.svg";
import { Colors } from "../../../theme";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import DashboardCard from "./Card";

export default function CatalogueCard({ allowed }) {
  const history = useHistory();
  const CreateCatalougueCard = styled.div`
    .card {
      margin-right: 1rem;
      min-height: 25em;
      margin-top: 0.5rem;
      padding: 1rem;
      border-radius: 0.5rem;
      &:hover {
        background: ${allowed && "#fffcf7"};
        cursor: ${allowed && "pointer"};
      }
      @media (max-width: 400px) {
        padding: 0rem;
      }
    }
  `;

  const handleClick = () => {
    if (allowed) {
      history.push("/create-collection");
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.CREATE_COLLECTION,
        GA.DESCRIPTION.CREATE_COLLECTION_CARD
      );
    }
  };
  return (
    <Tooltip
      trigger="hover"
      // visible={!allowed}
      title={!allowed && "You don’t have permission to create catalogues"}
    >
      <CreateCatalougueCard>
        <DashboardCard
          allowed={allowed}
          onClick={handleClick}
          icon={
            <img
              src={allowed ? CollectionIcon : DisabledCollectionIcon}
              alt="catlougue"
              height={"64px"}
              width={"64px"}
            />
          }
          title="Create Catalogue for a Buyer"
          subTitle="You can select and edit products you want to share with the
     buyer, and create a catalogue in 2 minutes"
          cta={
            <Button
              size="large"
              style={{
                padding: 0,
              }}
              type="link"
              disabled={!allowed}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.CREATE_COLLECTION,
                  GA.DESCRIPTION.CREATE_COLLECTION_BUTTON
                );
              }}
            >
              Create a catalogue
            </Button>
          }
        />
      </CreateCatalougueCard>
    </Tooltip>
  );
}
